// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:992px){.col-container .intro-text.content[data-v-30bbc608]{padding-right:3rem}}", ""]);
// Exports
module.exports = exports;
